/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios';

/* =======================
 * Types
 * ======================= */

export type FileNoteType = 'GENERAL' | 'REDEMPTION';

export type FileNote = {
  id: number;
  content: string;
  type: FileNoteType;
  hiddenCommunication: boolean;
  fileId: number;
  createdAt: string;
  updatedAt: string;
  user: {
    id: number;
    firstName: string;
    lastName: string;
  };
};

/* =======================
 * Payloads
 * ======================= */

export type CreateFileNotePayload = {
  fileId: number;
  content: string;
  type?: FileNoteType;
  hiddenCommunication?: boolean;
};

export type UpdateFileNotePayload = {
  content?: string;
  type?: FileNoteType;
  hiddenCommunication?: boolean;
};

/* =======================
 * API calls
 * ======================= */

/**
 * Get all notes by fileId
 */
export const getFileNotesByFileId = async (fileId: number) => {
  const { data } = await axios.get(`/file-notes/file/${fileId}`);
  return data as {
    success: boolean;
    data: FileNote[];
  };
};

/**
 * Create new file note
 */
export const createFileNote = async (payload: CreateFileNotePayload) => {
  const { data } = await axios.post('/file-notes', payload);
  return data;
};

/**
 * Update file note
 */
export const updateFileNote = async (id: number, payload: UpdateFileNotePayload) => {
  const { data } = await axios.put(`/file-notes/${id}`, payload);
  return data;
};

/**
 * Delete file note
 */
export const deleteFileNote = async (id: number) => {
  const { data } = await axios.delete(`/file-notes/${id}`);
  return data;
};
